import { render } from "./AuthCallback.vue?vue&type=template&id=1059e803"
import script from "./AuthCallback.vue?vue&type=script&lang=js"
export * from "./AuthCallback.vue?vue&type=script&lang=js"
script.render = render

export default script